import { DropdownData, InputType, FormField } from '@fitogest/reactive-form-builder/interfaces';
import { environment } from '../../../../../../../environments/environment';

import { list } from 'src/app/common/classes/request-builder';
import { ChoferModel, ObraModel } from 'src/app/models/ventas/tablas-maestras.model';
import { ClienteModel } from 'src/app/models/cliente.model';
import { MaquinariaModel } from 'src/app/models/trabajadores/maquinaria.model';
export class AlbaranesFormDefinition {

  public appName = environment.appName;
  public lastFieldChanged: string = '';

  public requestType: any;
  public model: any = {};

  public chofers: DropdownData<ChoferModel> = list();
  public clientes: DropdownData<ClienteModel> = list();
  public obras: DropdownData<ObraModel> = list();
  public maquinarias: DropdownData<MaquinariaModel> = list();
  public concepto1: DropdownData<string> = list();
  public concepto2: DropdownData<string> = list();
  public concepto3: DropdownData<string> = list();
  public concepto4: DropdownData<string> = list();



  public formFieldsLugar: FormField<any>[] = [
    {
        name: 'albaran_id',
        field: 'albaran_id',
        vinculatedFields: undefined,
        label: 'Albarán',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: Boolean(true), isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: Boolean(true),
        order: 1
    },
    {
        name: 'chofer',
        field: 'chofer',
        vinculatedFields: undefined,
        label: 'Chofer',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.chofers, dropdownConfiguration: { valuePrimaryKey: 'id' }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: Boolean(true), isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: Boolean(true),        values: this.chofers,

        order: 2
    },
    {
        name: 'fecha',
        field: 'fecha',
        vinculatedFields: undefined,
        label: 'Fecha',
        input: { type: InputType.CALENDAR, isEditable: true, calendarConfiguration: { calendarView: 'date', calendarDateFormat: 'dd/mm/yy' } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: Boolean(true), isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: Boolean(true),
        order: 3
    },
    {
        name: 'cliente',
        field: 'cliente',
        vinculatedFields: undefined,
        label: 'Cliente',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.clientes, dropdownConfiguration: { valuePrimaryKey: 'id' }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: Boolean(true), isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: Boolean(true),        values: this.clientes,

        order: 4
    },
    {
        name: 'direccion',
        field: 'direccion',
        vinculatedFields: undefined,
        label: 'Dirección',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 5
    },
    {
        name: 'cif',
        field: 'cif',
        vinculatedFields: undefined,
        label: 'C.I.F.',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 6
    },
    {
        name: 'poblacion',
        field: 'poblacion',
        vinculatedFields: undefined,
        label: 'Población',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 7
    },
    {
        name: 'cp',
        field: 'cp',
        vinculatedFields: undefined,
        label: 'C.P.',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 8
    },
    {
        name: 'telefono',
        field: 'telefono',
        vinculatedFields: undefined,
        label: 'Teléfono',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 9
    },
    {
        name: 'correo',
        field: 'correo',
        vinculatedFields: undefined,
        label: 'Correo',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 10
    },
    {
        name: 'obra',
        field: 'obra',
        vinculatedFields: undefined,
        label: 'Obra',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.obras, dropdownConfiguration: { valuePrimaryKey: 'id' }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.obras,

        order: 11
    },
];

  public formFieldsTratamiento: FormField<any>[] = [
    {
        name: 'cantidad1',
        field: 'cantidad1',
        vinculatedFields: undefined,
        label: 'Cantidad',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 1
    },
    {
        name: 'concepto1',
        field: 'concepto1',
        vinculatedFields: undefined,
        label: 'Concepto',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.concepto1, dropdownConfiguration: { valuePrimaryKey: 'id' }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.concepto1,

        order: 2
    },
    {
        name: 'precio1',
        field: 'precio1',
        vinculatedFields: undefined,
        label: 'Precio',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 3
    },
    {
        name: 'total1',
        field: 'total1',
        vinculatedFields: undefined,
        label: 'Total',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 4
    },
    {
        name: 'cantidad2',
        field: 'cantidad2',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 5
    },
    {
        name: 'concepto2',
        field: 'concepto2',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.concepto2, dropdownConfiguration: { valuePrimaryKey: 'id' }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.concepto2,

        order: 6
    },
    {
        name: 'precio2',
        field: 'precio2',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 7
    },
    {
        name: 'total2',
        field: 'total2',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 8
    },
    {
        name: 'cantidad3',
        field: 'cantidad3',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 9
    },
    {
        name: 'concepto3',
        field: 'concepto3',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.concepto3, dropdownConfiguration: { valuePrimaryKey: 'id' }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.concepto3,

        order: 10
    },
    {
        name: 'precio3',
        field: 'precio3',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 11
    },
    {
        name: 'total3',
        field: 'total3',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 12
    },
    {
        name: 'cantidad4',
        field: 'cantidad4',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 13
    },
    {
        name: 'concepto4',
        field: 'concepto4',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.concepto4, dropdownConfiguration: { valuePrimaryKey: 'id' }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.concepto4,

        order: 14
    },
    {
        name: 'precio4',
        field: 'precio4',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 15
    },
    {
        name: 'total4',
        field: 'total4',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 16
    },
    {
        name: 'trabajos_realizados',
        field: 'trabajos_realizados',
        vinculatedFields: undefined,
        label: 'Trabajos Realizados',
        input: { type: InputType.TEXTAREA, isEditable: true, textAreaConfiguration: { hasVoiceTranscription: Boolean(false), canTakePhoto: false, photoField: undefined } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 17
    },
    {
        name: 'conforme',
        field: 'conforme',
        vinculatedFields: undefined,
        label: 'Conforme',
        input: { type: InputType.TEXTAREA, isEditable: true, textAreaConfiguration: { hasVoiceTranscription: Boolean(false), canTakePhoto: false, photoField: undefined } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 18
    },
    {
        name: 'image',
        field: 'image',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.HIDDEN, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 19
    },
    {
        name: 'contabilizado',
        field: 'contabilizado',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.HIDDEN, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 20
    },
    {
        name: 'enviado',
        field: 'enviado',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.HIDDEN, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 21
    },
];

  public formChanges(tag: string) {
    this.lastFieldChanged = tag;
  }
}